export default __webpack_public_path__ + "static/media/subWalletIcon.875e4a75.svg";